<section id="section08">

    <div class="container">

        <div class="section-header">
            <h2>{{ data.TITULO }}</h2>
        </div>

        <div class="row d-flex justify-content-around">
            <div *ngFor="let cliente of data.CLIENTES; let index = index" class="d-flex justify-content-center align-items-stretch">
                <div class="d-flex justify-content-center align-items-center empresa">
                    <img src="{{ cliente.IMAGEM.URL }}" alt="{{ cliente.IMAGEM.DESCRICAO }}">
                </div>
            </div>
        </div>
 
    </div>

</section>